import Vue from 'vue'
import Vuex from 'vuex'
 
import apple from './apple' 
import load from './load'
import users from './users' 
import not  from './not'
import locationDetails from './locationDetails'
import time from './time' 


Vue.use(Vuex)

export const store = new Vuex.Store({ 
  modules:{
    apple:apple,  
    not: not ,
    locationDetails: locationDetails,
    load: load,
    users: users,
    time:time, 
  }
  
})